import { ManageUsageStatisticsPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/usage-statistics'].update({
        staticData: { title: { page: 'UsageStatistics.PageHeading' } },
        component: authGuard(ManageUsageStatisticsPage, { canViewUsageStatistics: true })
    });
};
